import RebookCanx from '@/views/RebookCanx/index.vue'

const RebookCanxRouter = {
  path: '/rebook-canx',
  name: 'RebookCanx',
  component: RebookCanx,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default RebookCanxRouter
